import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import axios from "axios";
import config from "../config";
import PageBanner from "./banner";
import WorkerLogoutButton from "./WorkerLogoutButton";

const WorkerLayout = () => {
  const workerID = localStorage.getItem("workerID");

  const [groupName, setGroupName] = useState("");
  const [loading, setLoading] = useState(true);

  const isLoggedIn = !!workerID;

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/worker/group/${workerID}`
        );
        setGroupName(res.data.groupName);
      } catch {
        setGroupName("Assigned Care Group");
      } finally {
        setLoading(false);
      }
    };

    if (workerID) fetchGroup();
  }, [workerID]);

  if (!isLoggedIn) return null;

  return (
    <>
      <PageBanner
        title="Worker Family Circle"
        subtitle=""
        rightContent={isLoggedIn && <WorkerLogoutButton />}
      />

      {!loading && (
        <div style={groupBadge}>
          You are supporting <strong>{groupName}</strong>
        </div>
      )}

      <Outlet />
    </>
  );
};

export default WorkerLayout;

const groupBadge = {
  padding: "10px 40px",
  background: "#e9f2f9",
  color: "#0E5580",
  fontSize: "15px"
};
